class Gallery {

    constructor() {
        $(".gallery").lightGallery({
            selector: '.gallery-item'
        });
    }

}

export default Gallery;


// WEBPACK FOOTER //
// ./resources/js/src/core/Gallery.js